import { apiClient } from '../config/api';

// FEAT-067 — AI-summarized caregiver experience (web client).

export interface CaregiverExperienceSummary {
  summaryText: string;
  generatedAt: string;
  fromCache: boolean;
  fallback: boolean;
}

interface ExperienceSummaryResponse {
  success: boolean;
  data: CaregiverExperienceSummary;
}

class CaregiverExperienceSummaryService {
  async getSummary(caregiverId: string): Promise<CaregiverExperienceSummary> {
    const response = await apiClient.get<ExperienceSummaryResponse>(
      `/caretakers/${caregiverId}/experience-summary`,
    );
    if (!response.data.success) {
      throw new Error('Failed to load experience summary');
    }
    return response.data.data;
  }
}

export const caregiverExperienceSummaryService = new CaregiverExperienceSummaryService();
